import { cva } from "class-variance-authority";
import { CircleIcon, TimerIcon } from "lucide-react";

import type { ParticipationHealth } from "@tudigo-monorepo/core-tudigo-api-models";
import { cn } from "@tudigo-monorepo/core-tudigo-theme";
import { useTranslation } from "@tudigo-monorepo/core-tudigo-translations";

const variants = cva("size-[11px]", {
  variants: {
    variant: {
      default: "text-neutral-900 size-[14px]",
      low: "text-error-500 fill-error-500",
      medium: "text-warning-500 fill-warning-500",
      high: "text-success-500 fill-success-500",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

type ParticipationHealthStatusProps = {
  health: ParticipationHealth | null;
  className?: string;
};

export function ParticipationHealthStatus({
  health,
  className,
}: ParticipationHealthStatusProps) {
  const { t } = useTranslation();

  const Icon = health === null ? TimerIcon : CircleIcon;
  const healthStatus = health ?? "default";

  return (
    <span
      className={cn(
        "body200-regular inline-flex items-center gap-x-2 text-neutral-900",
        className,
      )}
    >
      {t(
        `participations.web_app.participations_list_page.health.${healthStatus}`,
      )}
      <Icon className={cn(variants({ variant: healthStatus }))} />
    </span>
  );
}
